import { useRouteMatch } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import { Card, CardBody, Input, Label } from 'reactstrap';

const Sidebar = () => {
    const { push } = useHistory();
    const { url } = useRouteMatch();
    const { pathname } = useLocation();

    const filters = [
        {
            id: '1',
            title: 'All',
            path: 'all',
            defaultChecked: true,
        },
        {
            id: '2',
            title: 'ERC721',
            path: 'erc721',
            defaultChecked: false,
        },
        {
            id: '3',
            title: 'ERC1155',
            path: 'erc1155',
            defaultChecked: false,
        },
        {
            id: '4',
            title: 'ERC20',
            path: 'erc20',
            defaultChecked: false
        },
        {
            id: '5',
            title: "ERC721A",
            path: "erc721a",
            defaultChecked: false,
        },
        {
            id: '6',
            title: "ERC721PSI",
            path: "erc721psi",
            defaultChecked: false,
        },
    ];

    return (
        <div className="sidebar-detached sidebar-left">
            <div className="sidebar">
                <div>
                    <Card>
                        <CardBody>
                            <div id="product-categories">
                                <h6 className="filter-title">Filter</h6>
                                <ul className="list-unstyled categories-list">
                                    {filters.map((filter) => {
                                        return (
                                            <li key={filter.id}>
                                                <div className="form-check">
                                                    <Input
                                                        type="radio"
                                                        id={filter.id}
                                                        name="category-radio"
                                                        checked={
                                                            pathname
                                                                .split('/')
                                                                .at(-1) ===
                                                            filter.path
                                                        }
                                                        onChange={() =>
                                                            push(
                                                                `${url}/nft/${filter.path}`
                                                            )
                                                        }
                                                    />
                                                    <Label
                                                        className="form-check-label"
                                                        for={filter.id}
                                                    >
                                                        {filter.title}
                                                    </Label>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
